import * as React from 'react';
export const IcCowAdult = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.75 8h-.09C20.93 6.05 21 4.23 21 4a1 1 0 00-.62-.92 1 1 0 00-1.09.21 12.61 12.61 0 01-2.62 1.88A3.87 3.87 0 0014 4h-4a3.87 3.87 0 00-2.67 1.17 12.61 12.61 0 01-2.62-1.88 1 1 0 00-1.09-.21A1 1 0 003 4c0 .23.07 2.05 2.34 4h-.09A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.08.48.19.9.3 1.32.11.42.22.87.32 1.43A4.83 4.83 0 019 13h6a4.83 4.83 0 012.24.56c.1-.56.21-1 .32-1.43.11-.43.22-.84.3-1.32.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2.001 1 1 0 010 2zm6 0a1 1 0 110-2.002A1 1 0 0115 11zm0 4H9a3 3 0 000 6h6a3 3 0 000-6z'
      fill='currentColor'
    />
  </svg>
);
